<template>
  <DaiTarjetaContenedorMapa
    :permitir-colapso="false"
    class="distribucion-mapa-diagnostico"
    :class="{'hidden-header-on-mobile':hiddenHeader,'hidden-footer-on-mobile':hiddenFooter}"
    :usarLogoLibreria="false"
  >
    <div class="botones-contextos-mobile">
      Información sobre el contexto:
      <div>
        <button @click="hiddenHeader = !hiddenHeader" >BIOFÍSICO</button>
        <button @click="hiddenFooter = !hiddenFooter">SOCIO-TERRITORIAL</button>
      </div>

    </div>
    <template #header >
      <h4 class="titulo-contexto">CONTEXTO BIOFÍSICO</h4>
      <button class="btn-return-map" @click="hiddenHeader = !hiddenHeader"> MAPA <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"/></svg></button>
      <LeyendasHidrologia />
      <LeyendasFauna />
      <LeyendasVegetacion />
      <LeyendasEdafologia />
    </template>
    <template #footer>
      <h4 class="titulo-contexto">CONTEXTO SOCIO-TERRITORIAL</h4>
      <button class="btn-return-map" @click="hiddenFooter = !hiddenFooter"> MAPA <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"/></svg></button>
      <LeyendasAreasEstudio />
      <LeyendasPoblacion />
      <LeyendasMinas />
      <LeyendasUsoSuelo />
      <LeyendasPropiedadesSuelo />
    </template>
    <DaiMapa
      :extension="extentActualMapa"
      :noSalirDeExtension="[
        -100.1935832197897156, 18.0239143256855989, -97.3333685283348444,
        21.1881341913398984,
      ]"
      ref="mapa"
    >

      <button
      class="boton-calles"
      @click="mapaDeCallesEncendido = !mapaDeCallesEncendido"
      >
        <span
        >{{ mapaDeCallesEncendido ? "Quitar" : "Ver" }} mapa de
          calles
        </span>
      </button>
      <DaiCapaXyz />
      <DaiCapaXyz
      url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_only_labels/{z}/{x}/{y}.png"
      :z-index="12"
      :visible="mapaDeCallesEncendido"
      />

      <GrupoCapasHidrologia />
      <GrupoCapasAreasEstudio />
      <GrupoCapasFauna />
      <GrupoCapasVegetacion />
      <GrupoCapasEdafologia />
      <GrupoCapasPoblacion />
      <GrupoCapasMinas />
      <GrupoCapasUsoSuelo />
      <GrupoCapasPropiedadesSuelo/>
      <Fuentes/>
    </DaiMapa>
  </DaiTarjetaContenedorMapa>
</template>

<script>
import "./mapaDiagnostico.scss";

// Capas lado izquierdo (header)
import GrupoCapasHidrologia from "./GrupoCapasHidrologia.vue";
import LeyendasHidrologia from "./LeyendasHidrologia.vue";
import GrupoCapasFauna from "./GrupoCapasFauna.vue";
import LeyendasFauna from "./LeyendasFauna.vue"
import GrupoCapasVegetacion from "./GrupoCapasVegetacion.vue";
import LeyendasVegetacion from "./LeyendasVegetacion.vue";
import GrupoCapasEdafologia from "./GrupoCapasEdafologia.vue";
import LeyendasEdafologia from "./LeyendasEdafologia.vue";

// Capas lado derecho (footer)
import GrupoCapasAreasEstudio from "./GrupoCapasAreasEstudio.vue";
import LeyendasAreasEstudio from "./LeyendasAreasEstudio.vue";
import GrupoCapasPoblacion from "./GrupoCapasPoblacion.vue";
import LeyendasPoblacion from "./LeyendasPoblacion.vue";
import GrupoCapasMinas from "./GrupoCapasMinas.vue";
import LeyendasMinas from "./LeyendasMinas.vue";
import GrupoCapasUsoSuelo from "./GrupoCapasUsoSuelo.vue";
import LeyendasUsoSuelo from "./LeyendasUsoSuelo.vue"
import GrupoCapasPropiedadesSuelo from "./GrupoCapasPropiedadesSuelo.vue"
import LeyendasPropiedadesSuelo from "./LeyendasPropiedadesSuelo.vue"

import Fuentes from "./utils/Fuentes.vue"

import { mapState } from "vuex";

export default {
  data(){
    return {
      mapaDeCallesEncendido: false,
    }
  },
  computed: {
    ...mapState("mapa", ["capasAreasActivas","temasExpandidos"]),
    propiedadesSueloExpanded(){
      return this.temasExpandidos.propiedadesSuelo
    },
    extentActualMapa() {
      if (this.capasAreasActivas.length === 0) {
        return extensiones["areas_region_nororiental"];
      }
      const sortingArr = ['areas_region_nororiental','areas_subcuenca','areas_zona_pelt','areas_zona_federal_lago_texcoco','areas_obra_principal_naim']
      const sorted= [...this.capasAreasActivas].sort((a,b)=>{
        return sortingArr.indexOf(a) - sortingArr.indexOf(b);
      })
      return extensiones[sorted[0]];
    },
    hiddenHeader:{
      set(activo){
        this.$store.commit('mapa/setLeyendasBiofisicoActivasEnMobile',activo)
      },
      get(){
        return this.$store.state.mapa.leyendasBiofisicoActivasEnMobile
      }
    },
    hiddenFooter:{
      set(activo){
        this.$store.commit('mapa/setLeyendasSocioterritorialActivasEnMobile',activo)
      },
      get(){
        return this.$store.state.mapa.leyendasSocioterritorialActivasEnMobile
      }
    }
  },
  watch: {
    extentActualMapa() {
      setTimeout(() => {
        this.$refs.mapa.external_force_reset_view();
      }, 500);
    },
    propiedadesSueloExpanded(nuevoValor){
      if(nuevoValor){
        this.$refs.mapa.map.getView().fit(extensiones.areas_zona_federal_lago_texcoco,{duration:500,padding: [10, 10, 10, 10]})
      }
    }
  },
  components: {
    // Capas lado izquierdo (header)
    GrupoCapasHidrologia,
    LeyendasHidrologia,
    GrupoCapasFauna,
    LeyendasFauna,
    GrupoCapasVegetacion,
    LeyendasVegetacion,
    GrupoCapasEdafologia,
    LeyendasEdafologia,

    // Capas lado derecho (footer)
    GrupoCapasAreasEstudio,
    LeyendasAreasEstudio,
    GrupoCapasPoblacion,
    LeyendasPoblacion,
    GrupoCapasMinas,
    LeyendasMinas,
    GrupoCapasUsoSuelo,
    LeyendasUsoSuelo,
    GrupoCapasPropiedadesSuelo,
    LeyendasPropiedadesSuelo,

    Fuentes,
  },
  mounted(){
    if(this.propiedadesSueloExpanded){
      setTimeout(()=>{
        this.$refs.mapa.map.getView().fit(extensiones.areas_zona_federal_lago_texcoco,{duration:500,padding: [10, 10, 10, 10]})
      },700)
    }

  }
};

const extensiones = {
  areas_region_nororiental: [
    -99.1935832197897156, 19.0239143256855989, -98.3333685283348444,
    20.1881341913398984,
  ],
  areas_subcuenca: [
    -99.0491958416195786,19.3456575447357757, -98.6433592654919948,
    19.8045241102459784
  ],
  areas_zona_federal_lago_texcoco: [
    -99.0492145912004958, 19.4223490601912516, -98.9148413796941668,
    19.5849559793809291,
  ],
  areas_obra_principal_naim: [
    -99.0143992085565401, 19.4692347422165675, -98.9465393768061432,
    19.5532988345370242,
  ],
  areas_zona_pelt: [
    -99.1770457403863759,19.3662101103037116, -98.6346757702905137,
    19.6902296297033246,
  ],
};
</script>

<style lang="scss">
//otros estilos de prueba

.main-legend {
  .dai-map-shape > div.shape.square {
    border-radius: 20%;
  }

}
.card-map-container .card-map-header>* {
    margin-top: 16px;
    flex-grow: 1;
}
.card-map-container .card-map-footer .card-map-footer-container>* {
    margin:8px 5px;
    flex-grow: 1;
}
.card-map-container .card-map-footer {
  overflow-y: auto;
}

.dai-map-container{
  .loader{
    color:white
  }
}

.boton-calles{
  position: absolute;
  bottom: 1rem;
  left: calc(1rem + 35px);
  background-color: #FFFFFF;
  border: 1px solid #000000;
  border-radius: 5px;
  padding: 0.5em;
  color: #000000;
  line-height: 1;
  font-size: 14px;
  @media screen and (min-width: map-get($media-queries-limit, "mobile")) {
    bottom: .5rem;
  }
  span{
    line-height: 1;
  }
  &:hover{
    background-color: white;
    color: black;
  }
}

.ol-control.dai-enlace-conacyt{
  a{
    &:hover{
      background-color: transparent;
    }
  }
}
</style>
